var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.614 10.3683L12 3L2.38611 10.3683C1.95016 10.7024 1.87162 11.3215 2.21069 11.7511C2.54976 12.1806 3.17804 12.258 3.61399 11.9239L12 5.49671L20.3861 11.9239C20.8221 12.258 21.4503 12.1806 21.7894 11.7511C22.1285 11.3215 22.0499 10.7024 21.614 10.3683Z",
    fill: "#A5ACBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15C6 14.4477 5.55228 14 5 14C4.44772 14 4 14.4477 4 15V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V15C20 14.4477 19.5523 14 19 14C18.4477 14 18 14.4477 18 15V19H6V15Z",
    fill: "#A5ACBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7b5a80f193b57f65cfda59fb1437c708.svg";
export { ForwardRef as ReactComponent };